/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Sets a value in a Map, evicting the oldest entry if the map exceeds maxSize.
 * This provides a simple LRU-like eviction for static Map caches to prevent
 * unbounded memory growth on low-memory devices.
 *
 * @param map - The Map to insert into.
 * @param key - The key to set.
 * @param value - The value to set.
 * @param maxSize - Maximum number of entries before eviction (default: 100).
 */
export function lruSet<K, V>(map: Map<K, V>, key: K, value: V, maxSize: number = 100): void {
    if (maxSize <= 0) {
        return;
    }
    if (map.size >= maxSize && !map.has(key)) {
        const oldest = map.keys().next();
        if (!oldest.done) {
            map.delete(oldest.value);
        }
    }
    map.set(key, value);
}
